import React from "react";
import { useSelector } from "react-redux";
import TextField from "../../../../../components/input-fields/TextField";

const ContactNameSection = ({ contact, index, onContactUpdated }) => {
  const { config, contactErrors } = useSelector((state) => state.companyDirectory);
  const agentLanguage = useSelector((state) => state.info.agentLanguage);
  const voices = useSelector((state) => state.info.voices);
  const updatedVoice = useSelector((state) => state.info.updatedVoice);
  const selectedVoice = voices?.find((voice) => voice.id === updatedVoice);
  const selectedLanguage = selectedVoice?.language || agentLanguage || "en-US";
  const regexByLanguage = {
    "en-US": { inputRegex: /^[a-zA-Z\s]*$/, regexMessage: "Only characters and spaces are allowed" },
    "he-IL": {
      inputRegex: /^[a-zA-Zא-ת\s]*$/,
      regexMessage: "Only Hebrew and English characters and spaces are allowed",
    },
  };

  const onContactUpdatedInternal = (key, value) => {
    onContactUpdated(index, key, value);
  };

  return (
    <div className="flex flex-col gap-8">
      <TextField
        title="Name"
        value={contact.name}
        placeholder={`Name`}
        onChange={(value) => onContactUpdatedInternal("name", value)}
        required={config.minNameCharacters > 0}
        maxCharacters={config.maxNameCharacters}
        errorMessage={contactErrors[index]?.name}
        regexMessage={regexByLanguage[selectedLanguage]?.regexMessage}
        inputRegex={regexByLanguage[selectedLanguage]?.inputRegex}
      />
      <TextField
        title="Description"
        value={contact.description}
        placeholder={`Description`}
        onChange={(value) => onContactUpdatedInternal("description", value)}
        required={config.minDescriptionCharacters > 0}
        maxCharacters={config.maxDescriptionCharacters}
        errorMessage={contactErrors[index]?.description}
        regexMessage={regexByLanguage[selectedLanguage]?.regexMessage}
        inputRegex={regexByLanguage[selectedLanguage]?.inputRegex}
      />
    </div>
  );
};

export default ContactNameSection;
